import { useTranslation } from 'react-i18next';

import { useRegionStore } from '@packages/stores';
import { BOOST_CODE } from '@packages/types';
import { isBoostEligible } from '@packages/utils';

import { BoostListItem } from '@components/boostListItem';
import { Notification } from '@elements/notification';
import { Text } from '@elements/text';
import { useTripStore } from '@store';

export const PreTripCancellation = () => {
  const preTripCancellationBoost = useTripStore(state =>
    state.trip?.boosts?.find(boost => boost.code === BOOST_CODE.PRE_TRIP_CANCELLATION),
  );
  const { t } = useTranslation();
  const region = useRegionStore(state => state?.region);

  const isEligible = isBoostEligible(preTripCancellationBoost, region);
  if (!preTripCancellationBoost) {
    return null;
  }
  return (
    <div className="space-y-s16 pb-s32">
      <Text variant="subTitle-20/sb">{t('myQuote.preTripCancellation.title')}</Text>
      <Text>{t('myQuote.preTripCancellation.description', {})}</Text>
      {!isEligible && (
        <Notification
          header={t('myQuote.preTripCancellation.notification.header')}
          body={t('myQuote.preTripCancellation.notification.body')}
        />
      )}
      <BoostListItem boost={preTripCancellationBoost} />
      <div className="lg:border-b  lg:pt-s16" />
    </div>
  );
};
